import styled, { css } from 'styled-components'

/** The composer's context chip above the textarea: the active chart on the
 *  charts page, or what the user is looking at on a 2.1 dashboard. Under a
 *  sent message it is pressable, or grayed out when it leads nowhere. */
export const ContextChip = styled.div<{
  $clickable?: boolean
  $disabled?: boolean
}>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  /* Capped at 230px, but never wider than a narrow panel. */
  max-width: min(230px, 100%);
  padding: 4px 10px;
  margin-bottom: 8px;
  border: none;
  background: #5072a414;
  color: #4f72a4;
  border-radius: 6px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ${({ $clickable }) =>
    $clickable &&
    css`
      cursor: pointer;

      &:hover {
        background: #5072a429;
      }

      &:focus-visible {
        outline: 2px solid var(--color-reflection-blue-500);
        outline-offset: 2px;
      }
    `}

  ${({ $disabled }) =>
    $disabled &&
    css`
      background: #0000000a;
      color: #00000073;
      cursor: not-allowed;
    `}
`

export const ContextChipRemove = styled.button`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: inherit;
  font-size: 10px;
  cursor: pointer;

  &:hover {
    background: #5072a429;
  }

  &:focus-visible {
    outline: 2px solid var(--color-reflection-blue-500);
    outline-offset: 2px;
  }
`

/**
 * Fixed box for the chip's chart-type icon. The freeform icons carry an inline
 * `width/height: 100%` on their <svg> root, which beats any stylesheet rule on
 * the svg itself — so the size lives here and the svg fills it.
 */
export const ContextChipIcon = styled.div`
  display: inline-flex;
  flex-shrink: 0;
  width: 16px;
  height: 12px;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  /* Drop the thumbnails' white 72x56 card so the icon reads as a glyph. */
  rect[width='72'][height='56'] {
    fill: transparent;
  }
`
